import { OwcIcon, OwcTypography } from "@one/react";
import { IconStatus } from "../../../constants";
import { formatUserDisplay, USER_FORMAT_PRESETS } from "../../../utils/helpers/text";
import { useSelector } from "react-redux";
import { getBookingCategory, getBookingDisplayText } from "../helpFunctions";

const PopoverBookingTitle = ({ data }) => {
  const eventData = data?.eventData;
  const usersList = useSelector((state) => state.users.users);

  let list = usersList.map((item) => ({
    ...item,
    key: item.email,
    value: formatUserDisplay(item, USER_FORMAT_PRESETS.nameOnly),
  }));

  const bookingBy = eventData?.createdBy;
  const user = list.find((user) => user?.userId === bookingBy);

  const displayText = getBookingDisplayText(eventData);

  const iconDetails = IconStatus.find((i) => i.text === displayText) ||
    IconStatus.find((i) => i.text === getBookingCategory(eventData?.type));

  return (
    <div>
      <div style={{ display: "flex" }}>
        <OwcIcon
          type="outlined"
          name={iconDetails?.icon}
          style={{
            color: iconDetails?.color,
            backgroundColor: `${iconDetails?.backgroundColor}`,
            width:'24px',
            height:'24px',
            fontSize:16,
            textAlign:"center",
            lineHeight:"24px",
            borderRadius:7,
          }}
        />
        <OwcTypography variant="button" style={{ paddingLeft: 10, color: iconDetails?.color }}>
          {displayText + ` by ${user?.givenName} ${user?.familyName} (${user?.userId.split("_").pop()})`}
        </OwcTypography>
      </div>
    </div>
  );
};

export default PopoverBookingTitle;
